import { toast } from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { teacherAssessmentEndpoints } from "../apis";

const { SUBMIT_ASSESSMENT_API, GET_ASSESSMENTS_API } = teacherAssessmentEndpoints;

// 1. Submit a new assessment
export function submitAssessment(data) {
    // console.log("api",SUBMIT_ASSESSMENT_API)
    // console.log("data",data)
  return async () => {
    const toastId = toast.loading("Submitting assessment...");
    try {
     // const token = JSON.parse(localStorage.getItem("token"));
      const response = await apiConnector("POST", SUBMIT_ASSESSMENT_API, data);

      toast.success("Assessment submitted successfully");
      return response.data;
    } catch (error) {
     // console.error("SUBMIT ASSESSMENT ERROR:", error);
     // toast.error("Failed to submit assessment");
      return null;
    } finally {
      toast.dismiss(toastId);
    }
  };
}

// 2. Get all assessments
export function getAssessments() {
  return async () => {
    const toastId = toast.loading("Loading assessments...");
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await apiConnector("GET", GET_ASSESSMENTS_API, null, {
        Authorization: `Bearer ${token}`,
      });

      toast.success("Assessments loaded");
      return response.data; // array of assessments
    } catch (error) {
      console.error("GET ASSESSMENTS ERROR:", error);
      toast.error("Failed to load assessments");
      return [];
    } finally {
      toast.dismiss(toastId);
    }
  };
}
